export const getSrcImage = (isCover: boolean, image: any) => {
  const { srcThumbnail, srcCover } = image;
  if (isCover && srcCover && srcCover !== undefined) return srcCover;
  if (!isCover && srcThumbnail && srcThumbnail !== undefined) return srcThumbnail;
};
